/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkInProgressRouteImport } from './routes/work-in-progress'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as QuoteApprovalRouteImport } from './routes/quote-approval'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as ResourcePlanningIndexRouteImport } from './routes/resource-planning/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as OldPlanningIndexRouteImport } from './routes/old-planning/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as ExpensesIndexRouteImport } from './routes/expenses/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as ContractorsIndexRouteImport } from './routes/contractors/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as BrandsIndexRouteImport } from './routes/brands/index'
import { Route as BankIndexRouteImport } from './routes/bank/index'
import { Route as Accept_email_deliveryIndexRouteImport } from './routes/accept_email_delivery/index'
import { Route as TimeTrackingDayRouteImport } from './routes/time-tracking/day'
import { Route as TemplatesTaskGroupsRouteImport } from './routes/templates/task-groups'
import { Route as TemplatesProjectsRouteImport } from './routes/templates/projects'
import { Route as ReportsUtilizationRouteImport } from './routes/reports/utilization'
import { Route as ReportsUserProfitRouteImport } from './routes/reports/user-profit'
import { Route as ReportsUserMonthlyReportRouteImport } from './routes/reports/user-monthly-report'
import { Route as ReportsTimeReportRouteImport } from './routes/reports/time-report'
import { Route as ReportsProfitabilityByProjectRouteImport } from './routes/reports/profitability-by-project'
import { Route as ReportsProfitabilityByBrandRouteImport } from './routes/reports/profitability-by-brand'
import { Route as ReportsProfitAndLossRouteImport } from './routes/reports/profit-and-loss'
import { Route as ReportsInvoicedByProjectRouteImport } from './routes/reports/invoiced-by-project'
import { Route as ReportsInvoicedByBrandRouteImport } from './routes/reports/invoiced-by-brand'
import { Route as ReportsInvoicedAndProfitabilityByProjectRouteImport } from './routes/reports/invoiced-and-profitability-by-project'
import { Route as ReportsInvoicedAndProfitabilityByBrandRouteImport } from './routes/reports/invoiced-and-profitability-by-brand'
import { Route as ReportsBudgetExceededRouteImport } from './routes/reports/budget-exceeded'
import { Route as ProjectsTimeReportRouteImport } from './routes/projects/time-report'
import { Route as ProjectsTimeBillingRouteImport } from './routes/projects/time-billing'
import { Route as ProjectsTasksRouteImport } from './routes/projects/tasks'
import { Route as ProjectsSettingsRouteImport } from './routes/projects/settings'
import { Route as ProjectsPlannedExpensesRouteImport } from './routes/projects/planned-expenses'
import { Route as ProjectsInvoicingPlanRouteImport } from './routes/projects/invoicing-plan'
import { Route as ProjectsEditRouteImport } from './routes/projects/edit'
import { Route as ProjectsDocumentsRouteImport } from './routes/projects/documents'
import { Route as ProjectsDetailRouteImport } from './routes/projects/detail'
import { Route as ProjectsCreateTemplateRouteImport } from './routes/projects/create-template'
import { Route as ProjectsCreateFromTemplateRouteImport } from './routes/projects/create-from-template'
import { Route as ProjectsCreateRouteImport } from './routes/projects/create'
import { Route as ProjectsBudgetsOldRouteImport } from './routes/projects/budgets-old'
import { Route as ProjectsBudgetRouteImport } from './routes/projects/budget'
import { Route as ExpensesEditRouteImport } from './routes/expenses/edit'
import { Route as ExpensesCreateRouteImport } from './routes/expenses/create'
import { Route as CreditAccountsGlobalDetailRouteImport } from './routes/credit-accounts/global-detail'
import { Route as CreditAccountsGlobalRouteImport } from './routes/credit-accounts/global'
import { Route as CreditAccountsDetailRouteImport } from './routes/credit-accounts/detail'
import { Route as ContractorsDetailRouteImport } from './routes/contractors/detail'
import { Route as ClientsProjectsRouteImport } from './routes/clients/projects'
import { Route as ClientsDocumentsRouteImport } from './routes/clients/documents'
import { Route as ClientsDetailRouteImport } from './routes/clients/detail'
import { Route as ClientsCreditAccountsRouteImport } from './routes/clients/credit-accounts'
import { Route as BudgetsQuotesRouteImport } from './routes/budgets/quotes'
import { Route as BudgetsPositionsRouteImport } from './routes/budgets/positions'
import { Route as BudgetsHourlyRatesRouteImport } from './routes/budgets/hourly-rates'
import { Route as BudgetsExportRouteImport } from './routes/budgets/export'
import { Route as BudgetsEditQuoteRouteImport } from './routes/budgets/edit-quote'
import { Route as BrandsProjectsRouteImport } from './routes/brands/projects'
import { Route as BrandsHourlyRatesAndCommissionsRouteImport } from './routes/brands/hourly-rates-and-commissions'
import { Route as BrandsDocumentsRouteImport } from './routes/brands/documents'
import { Route as BrandsDetailRouteImport } from './routes/brands/detail'
import { Route as BrandsCreditAccountsRouteImport } from './routes/brands/credit-accounts'
import { Route as UsersPartnerAccessIndexRouteImport } from './routes/users/partner-access/index'
import { Route as UsersClientAccessIndexRouteImport } from './routes/users/client-access/index'
import { Route as TasksStarredIndexRouteImport } from './routes/tasks/starred/index'
import { Route as TasksPinnedIndexRouteImport } from './routes/tasks/pinned/index'
import { Route as TasksMyIndexRouteImport } from './routes/tasks/my/index'
import { Route as TasksMyWatchedIndexRouteImport } from './routes/tasks/my-watched/index'
import { Route as TasksMyCurrentIndexRouteImport } from './routes/tasks/my-current/index'
import { Route as TasksMyCreatedIndexRouteImport } from './routes/tasks/my-created/index'
import { Route as TasksHighlightedIndexRouteImport } from './routes/tasks/highlighted/index'
import { Route as ResourcePlanningMyWeekIndexRouteImport } from './routes/resource-planning/my-week/index'
import { Route as ProjectsBudgetsIndexRouteImport } from './routes/projects/budgets/index'
import { Route as InvoicesProformaInvoicesIndexRouteImport } from './routes/invoices/proforma-invoices/index'
import { Route as InvoicesOutgoingInvoicesIndexRouteImport } from './routes/invoices/outgoing-invoices/index'
import { Route as InvoicesInvoicingPlanIndexRouteImport } from './routes/invoices/invoicing-plan/index'
import { Route as InvoicesForInvoicingIndexRouteImport } from './routes/invoices/for-invoicing/index'
import { Route as InvoicesCreditAccountsIndexRouteImport } from './routes/invoices/credit-accounts/index'
import { Route as BudgetsProposalsIndexRouteImport } from './routes/budgets/proposals/index'
import { Route as ProjectsBudgetsEditRouteImport } from './routes/projects/budgets/edit'
import { Route as ProjectsBudgetsCreateRouteImport } from './routes/projects/budgets/create'
import { Route as InvoicesProformaInvoicesEditRouteImport } from './routes/invoices/proforma-invoices/edit'
import { Route as InvoicesProformaInvoicesDuplicateRouteImport } from './routes/invoices/proforma-invoices/duplicate'
import { Route as InvoicesProformaInvoicesDetailRouteImport } from './routes/invoices/proforma-invoices/detail'
import { Route as InvoicesOutgoingInvoicesEditRouteImport } from './routes/invoices/outgoing-invoices/edit'
import { Route as InvoicesOutgoingInvoicesDuplicateRouteImport } from './routes/invoices/outgoing-invoices/duplicate'
import { Route as InvoicesOutgoingInvoicesDetailRouteImport } from './routes/invoices/outgoing-invoices/detail'
import { Route as InvoicesInvoicingPlanAutomatedRouteImport } from './routes/invoices/invoicing-plan/automated'
import { Route as InvoicesForInvoicingEditRouteImport } from './routes/invoices/for-invoicing/edit'
import { Route as InvoicesForInvoicingDuplicateRouteImport } from './routes/invoices/for-invoicing/duplicate'
import { Route as InvoicesForInvoicingCreateProformaRouteImport } from './routes/invoices/for-invoicing/create-proforma'
import { Route as InvoicesForInvoicingCreateInvoiceRouteImport } from './routes/invoices/for-invoicing/create-invoice'
import { Route as InvoicesForInvoicingCreateCreditNoteRouteImport } from './routes/invoices/for-invoicing/create-credit-note'
import { Route as BudgetsProposalsCreateRouteImport } from './routes/budgets/proposals/create'
import { Route as AuthTwoFactorSuccessRouteImport } from './routes/auth/two-factor/success'
import { Route as AuthTwoFactorEnableRouteImport } from './routes/auth/two-factor/enable'
import { Route as AuthTwoFactorConfirmRouteImport } from './routes/auth/two-factor/confirm'
import { Route as AuthTwoFactorChallengeRouteImport } from './routes/auth/two-factor/challenge'

const WorkInProgressRoute = WorkInProgressRouteImport.update({
  id: '/work-in-progress',
  path: '/work-in-progress',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteApprovalRoute = QuoteApprovalRouteImport.update({
  id: '/quote-approval',
  path: '/quote-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcePlanningIndexRoute = ResourcePlanningIndexRouteImport.update({
  id: '/resource-planning/',
  path: '/resource-planning/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const OldPlanningIndexRoute = OldPlanningIndexRouteImport.update({
  id: '/old-planning/',
  path: '/old-planning/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIndexRoute = ExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsIndexRoute = ContractorsIndexRouteImport.update({
  id: '/contractors/',
  path: '/contractors/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => rootRouteImport,
} as any)
const BankIndexRoute = BankIndexRouteImport.update({
  id: '/bank/',
  path: '/bank/',
  getParentRoute: () => rootRouteImport,
} as any)
const Accept_email_deliveryIndexRoute =
  Accept_email_deliveryIndexRouteImport.update({
    id: '/accept_email_delivery/',
    path: '/accept_email_delivery/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TimeTrackingDayRoute = TimeTrackingDayRouteImport.update({
  id: '/time-tracking/day',
  path: '/time-tracking/day',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTaskGroupsRoute = TemplatesTaskGroupsRouteImport.update({
  id: '/templates/task-groups',
  path: '/templates/task-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesProjectsRoute = TemplatesProjectsRouteImport.update({
  id: '/templates/projects',
  path: '/templates/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsUtilizationRoute = ReportsUtilizationRouteImport.update({
  id: '/reports/utilization',
  path: '/reports/utilization',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsUserProfitRoute = ReportsUserProfitRouteImport.update({
  id: '/reports/user-profit',
  path: '/reports/user-profit',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsUserMonthlyReportRoute =
  ReportsUserMonthlyReportRouteImport.update({
    id: '/reports/user-monthly-report',
    path: '/reports/user-monthly-report',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsTimeReportRoute = ReportsTimeReportRouteImport.update({
  id: '/reports/time-report',
  path: '/reports/time-report',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsProfitabilityByProjectRoute =
  ReportsProfitabilityByProjectRouteImport.update({
    id: '/reports/profitability-by-project',
    path: '/reports/profitability-by-project',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsProfitabilityByBrandRoute =
  ReportsProfitabilityByBrandRouteImport.update({
    id: '/reports/profitability-by-brand',
    path: '/reports/profitability-by-brand',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsProfitAndLossRoute = ReportsProfitAndLossRouteImport.update({
  id: '/reports/profit-and-loss',
  path: '/reports/profit-and-loss',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsInvoicedByProjectRoute =
  ReportsInvoicedByProjectRouteImport.update({
    id: '/reports/invoiced-by-project',
    path: '/reports/invoiced-by-project',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsInvoicedByBrandRoute = ReportsInvoicedByBrandRouteImport.update({
  id: '/reports/invoiced-by-brand',
  path: '/reports/invoiced-by-brand',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsInvoicedAndProfitabilityByProjectRoute =
  ReportsInvoicedAndProfitabilityByProjectRouteImport.update({
    id: '/reports/invoiced-and-profitability-by-project',
    path: '/reports/invoiced-and-profitability-by-project',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsInvoicedAndProfitabilityByBrandRoute =
  ReportsInvoicedAndProfitabilityByBrandRouteImport.update({
    id: '/reports/invoiced-and-profitability-by-brand',
    path: '/reports/invoiced-and-profitability-by-brand',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsBudgetExceededRoute = ReportsBudgetExceededRouteImport.update({
  id: '/reports/budget-exceeded',
  path: '/reports/budget-exceeded',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsTimeReportRoute = ProjectsTimeReportRouteImport.update({
  id: '/projects/time-report',
  path: '/projects/time-report',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsTimeBillingRoute = ProjectsTimeBillingRouteImport.update({
  id: '/projects/time-billing',
  path: '/projects/time-billing',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsTasksRoute = ProjectsTasksRouteImport.update({
  id: '/projects/tasks',
  path: '/projects/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsSettingsRoute = ProjectsSettingsRouteImport.update({
  id: '/projects/settings',
  path: '/projects/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsPlannedExpensesRoute = ProjectsPlannedExpensesRouteImport.update({
  id: '/projects/planned-expenses',
  path: '/projects/planned-expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsInvoicingPlanRoute = ProjectsInvoicingPlanRouteImport.update({
  id: '/projects/invoicing-plan',
  path: '/projects/invoicing-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsEditRoute = ProjectsEditRouteImport.update({
  id: '/projects/edit',
  path: '/projects/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsDocumentsRoute = ProjectsDocumentsRouteImport.update({
  id: '/projects/documents',
  path: '/projects/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsDetailRoute = ProjectsDetailRouteImport.update({
  id: '/projects/detail',
  path: '/projects/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsCreateTemplateRoute = ProjectsCreateTemplateRouteImport.update({
  id: '/projects/create-template',
  path: '/projects/create-template',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsCreateFromTemplateRoute =
  ProjectsCreateFromTemplateRouteImport.update({
    id: '/projects/create-from-template',
    path: '/projects/create-from-template',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsCreateRoute = ProjectsCreateRouteImport.update({
  id: '/projects/create',
  path: '/projects/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsBudgetsOldRoute = ProjectsBudgetsOldRouteImport.update({
  id: '/projects/budgets-old',
  path: '/projects/budgets-old',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsBudgetRoute = ProjectsBudgetRouteImport.update({
  id: '/projects/budget',
  path: '/projects/budget',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesEditRoute = ExpensesEditRouteImport.update({
  id: '/expenses/edit',
  path: '/expenses/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesCreateRoute = ExpensesCreateRouteImport.update({
  id: '/expenses/create',
  path: '/expenses/create',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditAccountsGlobalDetailRoute =
  CreditAccountsGlobalDetailRouteImport.update({
    id: '/credit-accounts/global-detail',
    path: '/credit-accounts/global-detail',
    getParentRoute: () => rootRouteImport,
  } as any)
const CreditAccountsGlobalRoute = CreditAccountsGlobalRouteImport.update({
  id: '/credit-accounts/global',
  path: '/credit-accounts/global',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditAccountsDetailRoute = CreditAccountsDetailRouteImport.update({
  id: '/credit-accounts/detail',
  path: '/credit-accounts/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsDetailRoute = ContractorsDetailRouteImport.update({
  id: '/contractors/detail',
  path: '/contractors/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsProjectsRoute = ClientsProjectsRouteImport.update({
  id: '/clients/projects',
  path: '/clients/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsDocumentsRoute = ClientsDocumentsRouteImport.update({
  id: '/clients/documents',
  path: '/clients/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsDetailRoute = ClientsDetailRouteImport.update({
  id: '/clients/detail',
  path: '/clients/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsCreditAccountsRoute = ClientsCreditAccountsRouteImport.update({
  id: '/clients/credit-accounts',
  path: '/clients/credit-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsQuotesRoute = BudgetsQuotesRouteImport.update({
  id: '/budgets/quotes',
  path: '/budgets/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsPositionsRoute = BudgetsPositionsRouteImport.update({
  id: '/budgets/positions',
  path: '/budgets/positions',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsHourlyRatesRoute = BudgetsHourlyRatesRouteImport.update({
  id: '/budgets/hourly-rates',
  path: '/budgets/hourly-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsExportRoute = BudgetsExportRouteImport.update({
  id: '/budgets/export',
  path: '/budgets/export',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsEditQuoteRoute = BudgetsEditQuoteRouteImport.update({
  id: '/budgets/edit-quote',
  path: '/budgets/edit-quote',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsProjectsRoute = BrandsProjectsRouteImport.update({
  id: '/brands/projects',
  path: '/brands/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsHourlyRatesAndCommissionsRoute =
  BrandsHourlyRatesAndCommissionsRouteImport.update({
    id: '/brands/hourly-rates-and-commissions',
    path: '/brands/hourly-rates-and-commissions',
    getParentRoute: () => rootRouteImport,
  } as any)
const BrandsDocumentsRoute = BrandsDocumentsRouteImport.update({
  id: '/brands/documents',
  path: '/brands/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsDetailRoute = BrandsDetailRouteImport.update({
  id: '/brands/detail',
  path: '/brands/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsCreditAccountsRoute = BrandsCreditAccountsRouteImport.update({
  id: '/brands/credit-accounts',
  path: '/brands/credit-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersPartnerAccessIndexRoute = UsersPartnerAccessIndexRouteImport.update({
  id: '/users/partner-access/',
  path: '/users/partner-access/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersClientAccessIndexRoute = UsersClientAccessIndexRouteImport.update({
  id: '/users/client-access/',
  path: '/users/client-access/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksStarredIndexRoute = TasksStarredIndexRouteImport.update({
  id: '/tasks/starred/',
  path: '/tasks/starred/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksPinnedIndexRoute = TasksPinnedIndexRouteImport.update({
  id: '/tasks/pinned/',
  path: '/tasks/pinned/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksMyIndexRoute = TasksMyIndexRouteImport.update({
  id: '/tasks/my/',
  path: '/tasks/my/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksMyWatchedIndexRoute = TasksMyWatchedIndexRouteImport.update({
  id: '/tasks/my-watched/',
  path: '/tasks/my-watched/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksMyCurrentIndexRoute = TasksMyCurrentIndexRouteImport.update({
  id: '/tasks/my-current/',
  path: '/tasks/my-current/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksMyCreatedIndexRoute = TasksMyCreatedIndexRouteImport.update({
  id: '/tasks/my-created/',
  path: '/tasks/my-created/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksHighlightedIndexRoute = TasksHighlightedIndexRouteImport.update({
  id: '/tasks/highlighted/',
  path: '/tasks/highlighted/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcePlanningMyWeekIndexRoute =
  ResourcePlanningMyWeekIndexRouteImport.update({
    id: '/resource-planning/my-week/',
    path: '/resource-planning/my-week/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsBudgetsIndexRoute = ProjectsBudgetsIndexRouteImport.update({
  id: '/projects/budgets/',
  path: '/projects/budgets/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesProformaInvoicesIndexRoute =
  InvoicesProformaInvoicesIndexRouteImport.update({
    id: '/invoices/proforma-invoices/',
    path: '/invoices/proforma-invoices/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesOutgoingInvoicesIndexRoute =
  InvoicesOutgoingInvoicesIndexRouteImport.update({
    id: '/invoices/outgoing-invoices/',
    path: '/invoices/outgoing-invoices/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesInvoicingPlanIndexRoute =
  InvoicesInvoicingPlanIndexRouteImport.update({
    id: '/invoices/invoicing-plan/',
    path: '/invoices/invoicing-plan/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingIndexRoute =
  InvoicesForInvoicingIndexRouteImport.update({
    id: '/invoices/for-invoicing/',
    path: '/invoices/for-invoicing/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesCreditAccountsIndexRoute =
  InvoicesCreditAccountsIndexRouteImport.update({
    id: '/invoices/credit-accounts/',
    path: '/invoices/credit-accounts/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BudgetsProposalsIndexRoute = BudgetsProposalsIndexRouteImport.update({
  id: '/budgets/proposals/',
  path: '/budgets/proposals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsBudgetsEditRoute = ProjectsBudgetsEditRouteImport.update({
  id: '/projects/budgets/edit',
  path: '/projects/budgets/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsBudgetsCreateRoute = ProjectsBudgetsCreateRouteImport.update({
  id: '/projects/budgets/create',
  path: '/projects/budgets/create',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesProformaInvoicesEditRoute =
  InvoicesProformaInvoicesEditRouteImport.update({
    id: '/invoices/proforma-invoices/edit',
    path: '/invoices/proforma-invoices/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesProformaInvoicesDuplicateRoute =
  InvoicesProformaInvoicesDuplicateRouteImport.update({
    id: '/invoices/proforma-invoices/duplicate',
    path: '/invoices/proforma-invoices/duplicate',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesProformaInvoicesDetailRoute =
  InvoicesProformaInvoicesDetailRouteImport.update({
    id: '/invoices/proforma-invoices/detail',
    path: '/invoices/proforma-invoices/detail',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesOutgoingInvoicesEditRoute =
  InvoicesOutgoingInvoicesEditRouteImport.update({
    id: '/invoices/outgoing-invoices/edit',
    path: '/invoices/outgoing-invoices/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesOutgoingInvoicesDuplicateRoute =
  InvoicesOutgoingInvoicesDuplicateRouteImport.update({
    id: '/invoices/outgoing-invoices/duplicate',
    path: '/invoices/outgoing-invoices/duplicate',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesOutgoingInvoicesDetailRoute =
  InvoicesOutgoingInvoicesDetailRouteImport.update({
    id: '/invoices/outgoing-invoices/detail',
    path: '/invoices/outgoing-invoices/detail',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesInvoicingPlanAutomatedRoute =
  InvoicesInvoicingPlanAutomatedRouteImport.update({
    id: '/invoices/invoicing-plan/automated',
    path: '/invoices/invoicing-plan/automated',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingEditRoute =
  InvoicesForInvoicingEditRouteImport.update({
    id: '/invoices/for-invoicing/edit',
    path: '/invoices/for-invoicing/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingDuplicateRoute =
  InvoicesForInvoicingDuplicateRouteImport.update({
    id: '/invoices/for-invoicing/duplicate',
    path: '/invoices/for-invoicing/duplicate',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingCreateProformaRoute =
  InvoicesForInvoicingCreateProformaRouteImport.update({
    id: '/invoices/for-invoicing/create-proforma',
    path: '/invoices/for-invoicing/create-proforma',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingCreateInvoiceRoute =
  InvoicesForInvoicingCreateInvoiceRouteImport.update({
    id: '/invoices/for-invoicing/create-invoice',
    path: '/invoices/for-invoicing/create-invoice',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesForInvoicingCreateCreditNoteRoute =
  InvoicesForInvoicingCreateCreditNoteRouteImport.update({
    id: '/invoices/for-invoicing/create-credit-note',
    path: '/invoices/for-invoicing/create-credit-note',
    getParentRoute: () => rootRouteImport,
  } as any)
const BudgetsProposalsCreateRoute = BudgetsProposalsCreateRouteImport.update({
  id: '/budgets/proposals/create',
  path: '/budgets/proposals/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorSuccessRoute = AuthTwoFactorSuccessRouteImport.update({
  id: '/auth/two-factor/success',
  path: '/auth/two-factor/success',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorEnableRoute = AuthTwoFactorEnableRouteImport.update({
  id: '/auth/two-factor/enable',
  path: '/auth/two-factor/enable',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorConfirmRoute = AuthTwoFactorConfirmRouteImport.update({
  id: '/auth/two-factor/confirm',
  path: '/auth/two-factor/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorChallengeRoute = AuthTwoFactorChallengeRouteImport.update({
  id: '/auth/two-factor/challenge',
  path: '/auth/two-factor/challenge',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/quote-approval': typeof QuoteApprovalRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/work-in-progress': typeof WorkInProgressRoute
  '/brands/credit-accounts': typeof BrandsCreditAccountsRoute
  '/brands/detail': typeof BrandsDetailRoute
  '/brands/documents': typeof BrandsDocumentsRoute
  '/brands/hourly-rates-and-commissions': typeof BrandsHourlyRatesAndCommissionsRoute
  '/brands/projects': typeof BrandsProjectsRoute
  '/budgets/edit-quote': typeof BudgetsEditQuoteRoute
  '/budgets/export': typeof BudgetsExportRoute
  '/budgets/hourly-rates': typeof BudgetsHourlyRatesRoute
  '/budgets/positions': typeof BudgetsPositionsRoute
  '/budgets/quotes': typeof BudgetsQuotesRoute
  '/clients/credit-accounts': typeof ClientsCreditAccountsRoute
  '/clients/detail': typeof ClientsDetailRoute
  '/clients/documents': typeof ClientsDocumentsRoute
  '/clients/projects': typeof ClientsProjectsRoute
  '/contractors/detail': typeof ContractorsDetailRoute
  '/credit-accounts/detail': typeof CreditAccountsDetailRoute
  '/credit-accounts/global': typeof CreditAccountsGlobalRoute
  '/credit-accounts/global-detail': typeof CreditAccountsGlobalDetailRoute
  '/expenses/create': typeof ExpensesCreateRoute
  '/expenses/edit': typeof ExpensesEditRoute
  '/projects/budget': typeof ProjectsBudgetRoute
  '/projects/budgets-old': typeof ProjectsBudgetsOldRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/projects/create-from-template': typeof ProjectsCreateFromTemplateRoute
  '/projects/create-template': typeof ProjectsCreateTemplateRoute
  '/projects/detail': typeof ProjectsDetailRoute
  '/projects/documents': typeof ProjectsDocumentsRoute
  '/projects/edit': typeof ProjectsEditRoute
  '/projects/invoicing-plan': typeof ProjectsInvoicingPlanRoute
  '/projects/planned-expenses': typeof ProjectsPlannedExpensesRoute
  '/projects/settings': typeof ProjectsSettingsRoute
  '/projects/tasks': typeof ProjectsTasksRoute
  '/projects/time-billing': typeof ProjectsTimeBillingRoute
  '/projects/time-report': typeof ProjectsTimeReportRoute
  '/reports/budget-exceeded': typeof ReportsBudgetExceededRoute
  '/reports/invoiced-and-profitability-by-brand': typeof ReportsInvoicedAndProfitabilityByBrandRoute
  '/reports/invoiced-and-profitability-by-project': typeof ReportsInvoicedAndProfitabilityByProjectRoute
  '/reports/invoiced-by-brand': typeof ReportsInvoicedByBrandRoute
  '/reports/invoiced-by-project': typeof ReportsInvoicedByProjectRoute
  '/reports/profit-and-loss': typeof ReportsProfitAndLossRoute
  '/reports/profitability-by-brand': typeof ReportsProfitabilityByBrandRoute
  '/reports/profitability-by-project': typeof ReportsProfitabilityByProjectRoute
  '/reports/time-report': typeof ReportsTimeReportRoute
  '/reports/user-monthly-report': typeof ReportsUserMonthlyReportRoute
  '/reports/user-profit': typeof ReportsUserProfitRoute
  '/reports/utilization': typeof ReportsUtilizationRoute
  '/templates/projects': typeof TemplatesProjectsRoute
  '/templates/task-groups': typeof TemplatesTaskGroupsRoute
  '/time-tracking/day': typeof TimeTrackingDayRoute
  '/accept_email_delivery/': typeof Accept_email_deliveryIndexRoute
  '/bank/': typeof BankIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/old-planning/': typeof OldPlanningIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/resource-planning/': typeof ResourcePlanningIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/auth/two-factor/challenge': typeof AuthTwoFactorChallengeRoute
  '/auth/two-factor/confirm': typeof AuthTwoFactorConfirmRoute
  '/auth/two-factor/enable': typeof AuthTwoFactorEnableRoute
  '/auth/two-factor/success': typeof AuthTwoFactorSuccessRoute
  '/budgets/proposals/create': typeof BudgetsProposalsCreateRoute
  '/invoices/for-invoicing/create-credit-note': typeof InvoicesForInvoicingCreateCreditNoteRoute
  '/invoices/for-invoicing/create-invoice': typeof InvoicesForInvoicingCreateInvoiceRoute
  '/invoices/for-invoicing/create-proforma': typeof InvoicesForInvoicingCreateProformaRoute
  '/invoices/for-invoicing/duplicate': typeof InvoicesForInvoicingDuplicateRoute
  '/invoices/for-invoicing/edit': typeof InvoicesForInvoicingEditRoute
  '/invoices/invoicing-plan/automated': typeof InvoicesInvoicingPlanAutomatedRoute
  '/invoices/outgoing-invoices/detail': typeof InvoicesOutgoingInvoicesDetailRoute
  '/invoices/outgoing-invoices/duplicate': typeof InvoicesOutgoingInvoicesDuplicateRoute
  '/invoices/outgoing-invoices/edit': typeof InvoicesOutgoingInvoicesEditRoute
  '/invoices/proforma-invoices/detail': typeof InvoicesProformaInvoicesDetailRoute
  '/invoices/proforma-invoices/duplicate': typeof InvoicesProformaInvoicesDuplicateRoute
  '/invoices/proforma-invoices/edit': typeof InvoicesProformaInvoicesEditRoute
  '/projects/budgets/create': typeof ProjectsBudgetsCreateRoute
  '/projects/budgets/edit': typeof ProjectsBudgetsEditRoute
  '/budgets/proposals/': typeof BudgetsProposalsIndexRoute
  '/invoices/credit-accounts/': typeof InvoicesCreditAccountsIndexRoute
  '/invoices/for-invoicing/': typeof InvoicesForInvoicingIndexRoute
  '/invoices/invoicing-plan/': typeof InvoicesInvoicingPlanIndexRoute
  '/invoices/outgoing-invoices/': typeof InvoicesOutgoingInvoicesIndexRoute
  '/invoices/proforma-invoices/': typeof InvoicesProformaInvoicesIndexRoute
  '/projects/budgets/': typeof ProjectsBudgetsIndexRoute
  '/resource-planning/my-week/': typeof ResourcePlanningMyWeekIndexRoute
  '/tasks/highlighted/': typeof TasksHighlightedIndexRoute
  '/tasks/my-created/': typeof TasksMyCreatedIndexRoute
  '/tasks/my-current/': typeof TasksMyCurrentIndexRoute
  '/tasks/my-watched/': typeof TasksMyWatchedIndexRoute
  '/tasks/my/': typeof TasksMyIndexRoute
  '/tasks/pinned/': typeof TasksPinnedIndexRoute
  '/tasks/starred/': typeof TasksStarredIndexRoute
  '/users/client-access/': typeof UsersClientAccessIndexRoute
  '/users/partner-access/': typeof UsersPartnerAccessIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/quote-approval': typeof QuoteApprovalRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/work-in-progress': typeof WorkInProgressRoute
  '/brands/credit-accounts': typeof BrandsCreditAccountsRoute
  '/brands/detail': typeof BrandsDetailRoute
  '/brands/documents': typeof BrandsDocumentsRoute
  '/brands/hourly-rates-and-commissions': typeof BrandsHourlyRatesAndCommissionsRoute
  '/brands/projects': typeof BrandsProjectsRoute
  '/budgets/edit-quote': typeof BudgetsEditQuoteRoute
  '/budgets/export': typeof BudgetsExportRoute
  '/budgets/hourly-rates': typeof BudgetsHourlyRatesRoute
  '/budgets/positions': typeof BudgetsPositionsRoute
  '/budgets/quotes': typeof BudgetsQuotesRoute
  '/clients/credit-accounts': typeof ClientsCreditAccountsRoute
  '/clients/detail': typeof ClientsDetailRoute
  '/clients/documents': typeof ClientsDocumentsRoute
  '/clients/projects': typeof ClientsProjectsRoute
  '/contractors/detail': typeof ContractorsDetailRoute
  '/credit-accounts/detail': typeof CreditAccountsDetailRoute
  '/credit-accounts/global': typeof CreditAccountsGlobalRoute
  '/credit-accounts/global-detail': typeof CreditAccountsGlobalDetailRoute
  '/expenses/create': typeof ExpensesCreateRoute
  '/expenses/edit': typeof ExpensesEditRoute
  '/projects/budget': typeof ProjectsBudgetRoute
  '/projects/budgets-old': typeof ProjectsBudgetsOldRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/projects/create-from-template': typeof ProjectsCreateFromTemplateRoute
  '/projects/create-template': typeof ProjectsCreateTemplateRoute
  '/projects/detail': typeof ProjectsDetailRoute
  '/projects/documents': typeof ProjectsDocumentsRoute
  '/projects/edit': typeof ProjectsEditRoute
  '/projects/invoicing-plan': typeof ProjectsInvoicingPlanRoute
  '/projects/planned-expenses': typeof ProjectsPlannedExpensesRoute
  '/projects/settings': typeof ProjectsSettingsRoute
  '/projects/tasks': typeof ProjectsTasksRoute
  '/projects/time-billing': typeof ProjectsTimeBillingRoute
  '/projects/time-report': typeof ProjectsTimeReportRoute
  '/reports/budget-exceeded': typeof ReportsBudgetExceededRoute
  '/reports/invoiced-and-profitability-by-brand': typeof ReportsInvoicedAndProfitabilityByBrandRoute
  '/reports/invoiced-and-profitability-by-project': typeof ReportsInvoicedAndProfitabilityByProjectRoute
  '/reports/invoiced-by-brand': typeof ReportsInvoicedByBrandRoute
  '/reports/invoiced-by-project': typeof ReportsInvoicedByProjectRoute
  '/reports/profit-and-loss': typeof ReportsProfitAndLossRoute
  '/reports/profitability-by-brand': typeof ReportsProfitabilityByBrandRoute
  '/reports/profitability-by-project': typeof ReportsProfitabilityByProjectRoute
  '/reports/time-report': typeof ReportsTimeReportRoute
  '/reports/user-monthly-report': typeof ReportsUserMonthlyReportRoute
  '/reports/user-profit': typeof ReportsUserProfitRoute
  '/reports/utilization': typeof ReportsUtilizationRoute
  '/templates/projects': typeof TemplatesProjectsRoute
  '/templates/task-groups': typeof TemplatesTaskGroupsRoute
  '/time-tracking/day': typeof TimeTrackingDayRoute
  '/accept_email_delivery': typeof Accept_email_deliveryIndexRoute
  '/bank': typeof BankIndexRoute
  '/brands': typeof BrandsIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/contractors': typeof ContractorsIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/expenses': typeof ExpensesIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/old-planning': typeof OldPlanningIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/resource-planning': typeof ResourcePlanningIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/users': typeof UsersIndexRoute
  '/auth/two-factor/challenge': typeof AuthTwoFactorChallengeRoute
  '/auth/two-factor/confirm': typeof AuthTwoFactorConfirmRoute
  '/auth/two-factor/enable': typeof AuthTwoFactorEnableRoute
  '/auth/two-factor/success': typeof AuthTwoFactorSuccessRoute
  '/budgets/proposals/create': typeof BudgetsProposalsCreateRoute
  '/invoices/for-invoicing/create-credit-note': typeof InvoicesForInvoicingCreateCreditNoteRoute
  '/invoices/for-invoicing/create-invoice': typeof InvoicesForInvoicingCreateInvoiceRoute
  '/invoices/for-invoicing/create-proforma': typeof InvoicesForInvoicingCreateProformaRoute
  '/invoices/for-invoicing/duplicate': typeof InvoicesForInvoicingDuplicateRoute
  '/invoices/for-invoicing/edit': typeof InvoicesForInvoicingEditRoute
  '/invoices/invoicing-plan/automated': typeof InvoicesInvoicingPlanAutomatedRoute
  '/invoices/outgoing-invoices/detail': typeof InvoicesOutgoingInvoicesDetailRoute
  '/invoices/outgoing-invoices/duplicate': typeof InvoicesOutgoingInvoicesDuplicateRoute
  '/invoices/outgoing-invoices/edit': typeof InvoicesOutgoingInvoicesEditRoute
  '/invoices/proforma-invoices/detail': typeof InvoicesProformaInvoicesDetailRoute
  '/invoices/proforma-invoices/duplicate': typeof InvoicesProformaInvoicesDuplicateRoute
  '/invoices/proforma-invoices/edit': typeof InvoicesProformaInvoicesEditRoute
  '/projects/budgets/create': typeof ProjectsBudgetsCreateRoute
  '/projects/budgets/edit': typeof ProjectsBudgetsEditRoute
  '/budgets/proposals': typeof BudgetsProposalsIndexRoute
  '/invoices/credit-accounts': typeof InvoicesCreditAccountsIndexRoute
  '/invoices/for-invoicing': typeof InvoicesForInvoicingIndexRoute
  '/invoices/invoicing-plan': typeof InvoicesInvoicingPlanIndexRoute
  '/invoices/outgoing-invoices': typeof InvoicesOutgoingInvoicesIndexRoute
  '/invoices/proforma-invoices': typeof InvoicesProformaInvoicesIndexRoute
  '/projects/budgets': typeof ProjectsBudgetsIndexRoute
  '/resource-planning/my-week': typeof ResourcePlanningMyWeekIndexRoute
  '/tasks/highlighted': typeof TasksHighlightedIndexRoute
  '/tasks/my-created': typeof TasksMyCreatedIndexRoute
  '/tasks/my-current': typeof TasksMyCurrentIndexRoute
  '/tasks/my-watched': typeof TasksMyWatchedIndexRoute
  '/tasks/my': typeof TasksMyIndexRoute
  '/tasks/pinned': typeof TasksPinnedIndexRoute
  '/tasks/starred': typeof TasksStarredIndexRoute
  '/users/client-access': typeof UsersClientAccessIndexRoute
  '/users/partner-access': typeof UsersPartnerAccessIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/quote-approval': typeof QuoteApprovalRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/work-in-progress': typeof WorkInProgressRoute
  '/brands/credit-accounts': typeof BrandsCreditAccountsRoute
  '/brands/detail': typeof BrandsDetailRoute
  '/brands/documents': typeof BrandsDocumentsRoute
  '/brands/hourly-rates-and-commissions': typeof BrandsHourlyRatesAndCommissionsRoute
  '/brands/projects': typeof BrandsProjectsRoute
  '/budgets/edit-quote': typeof BudgetsEditQuoteRoute
  '/budgets/export': typeof BudgetsExportRoute
  '/budgets/hourly-rates': typeof BudgetsHourlyRatesRoute
  '/budgets/positions': typeof BudgetsPositionsRoute
  '/budgets/quotes': typeof BudgetsQuotesRoute
  '/clients/credit-accounts': typeof ClientsCreditAccountsRoute
  '/clients/detail': typeof ClientsDetailRoute
  '/clients/documents': typeof ClientsDocumentsRoute
  '/clients/projects': typeof ClientsProjectsRoute
  '/contractors/detail': typeof ContractorsDetailRoute
  '/credit-accounts/detail': typeof CreditAccountsDetailRoute
  '/credit-accounts/global': typeof CreditAccountsGlobalRoute
  '/credit-accounts/global-detail': typeof CreditAccountsGlobalDetailRoute
  '/expenses/create': typeof ExpensesCreateRoute
  '/expenses/edit': typeof ExpensesEditRoute
  '/projects/budget': typeof ProjectsBudgetRoute
  '/projects/budgets-old': typeof ProjectsBudgetsOldRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/projects/create-from-template': typeof ProjectsCreateFromTemplateRoute
  '/projects/create-template': typeof ProjectsCreateTemplateRoute
  '/projects/detail': typeof ProjectsDetailRoute
  '/projects/documents': typeof ProjectsDocumentsRoute
  '/projects/edit': typeof ProjectsEditRoute
  '/projects/invoicing-plan': typeof ProjectsInvoicingPlanRoute
  '/projects/planned-expenses': typeof ProjectsPlannedExpensesRoute
  '/projects/settings': typeof ProjectsSettingsRoute
  '/projects/tasks': typeof ProjectsTasksRoute
  '/projects/time-billing': typeof ProjectsTimeBillingRoute
  '/projects/time-report': typeof ProjectsTimeReportRoute
  '/reports/budget-exceeded': typeof ReportsBudgetExceededRoute
  '/reports/invoiced-and-profitability-by-brand': typeof ReportsInvoicedAndProfitabilityByBrandRoute
  '/reports/invoiced-and-profitability-by-project': typeof ReportsInvoicedAndProfitabilityByProjectRoute
  '/reports/invoiced-by-brand': typeof ReportsInvoicedByBrandRoute
  '/reports/invoiced-by-project': typeof ReportsInvoicedByProjectRoute
  '/reports/profit-and-loss': typeof ReportsProfitAndLossRoute
  '/reports/profitability-by-brand': typeof ReportsProfitabilityByBrandRoute
  '/reports/profitability-by-project': typeof ReportsProfitabilityByProjectRoute
  '/reports/time-report': typeof ReportsTimeReportRoute
  '/reports/user-monthly-report': typeof ReportsUserMonthlyReportRoute
  '/reports/user-profit': typeof ReportsUserProfitRoute
  '/reports/utilization': typeof ReportsUtilizationRoute
  '/templates/projects': typeof TemplatesProjectsRoute
  '/templates/task-groups': typeof TemplatesTaskGroupsRoute
  '/time-tracking/day': typeof TimeTrackingDayRoute
  '/accept_email_delivery/': typeof Accept_email_deliveryIndexRoute
  '/bank/': typeof BankIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/old-planning/': typeof OldPlanningIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/resource-planning/': typeof ResourcePlanningIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/auth/two-factor/challenge': typeof AuthTwoFactorChallengeRoute
  '/auth/two-factor/confirm': typeof AuthTwoFactorConfirmRoute
  '/auth/two-factor/enable': typeof AuthTwoFactorEnableRoute
  '/auth/two-factor/success': typeof AuthTwoFactorSuccessRoute
  '/budgets/proposals/create': typeof BudgetsProposalsCreateRoute
  '/invoices/for-invoicing/create-credit-note': typeof InvoicesForInvoicingCreateCreditNoteRoute
  '/invoices/for-invoicing/create-invoice': typeof InvoicesForInvoicingCreateInvoiceRoute
  '/invoices/for-invoicing/create-proforma': typeof InvoicesForInvoicingCreateProformaRoute
  '/invoices/for-invoicing/duplicate': typeof InvoicesForInvoicingDuplicateRoute
  '/invoices/for-invoicing/edit': typeof InvoicesForInvoicingEditRoute
  '/invoices/invoicing-plan/automated': typeof InvoicesInvoicingPlanAutomatedRoute
  '/invoices/outgoing-invoices/detail': typeof InvoicesOutgoingInvoicesDetailRoute
  '/invoices/outgoing-invoices/duplicate': typeof InvoicesOutgoingInvoicesDuplicateRoute
  '/invoices/outgoing-invoices/edit': typeof InvoicesOutgoingInvoicesEditRoute
  '/invoices/proforma-invoices/detail': typeof InvoicesProformaInvoicesDetailRoute
  '/invoices/proforma-invoices/duplicate': typeof InvoicesProformaInvoicesDuplicateRoute
  '/invoices/proforma-invoices/edit': typeof InvoicesProformaInvoicesEditRoute
  '/projects/budgets/create': typeof ProjectsBudgetsCreateRoute
  '/projects/budgets/edit': typeof ProjectsBudgetsEditRoute
  '/budgets/proposals/': typeof BudgetsProposalsIndexRoute
  '/invoices/credit-accounts/': typeof InvoicesCreditAccountsIndexRoute
  '/invoices/for-invoicing/': typeof InvoicesForInvoicingIndexRoute
  '/invoices/invoicing-plan/': typeof InvoicesInvoicingPlanIndexRoute
  '/invoices/outgoing-invoices/': typeof InvoicesOutgoingInvoicesIndexRoute
  '/invoices/proforma-invoices/': typeof InvoicesProformaInvoicesIndexRoute
  '/projects/budgets/': typeof ProjectsBudgetsIndexRoute
  '/resource-planning/my-week/': typeof ResourcePlanningMyWeekIndexRoute
  '/tasks/highlighted/': typeof TasksHighlightedIndexRoute
  '/tasks/my-created/': typeof TasksMyCreatedIndexRoute
  '/tasks/my-current/': typeof TasksMyCurrentIndexRoute
  '/tasks/my-watched/': typeof TasksMyWatchedIndexRoute
  '/tasks/my/': typeof TasksMyIndexRoute
  '/tasks/pinned/': typeof TasksPinnedIndexRoute
  '/tasks/starred/': typeof TasksStarredIndexRoute
  '/users/client-access/': typeof UsersClientAccessIndexRoute
  '/users/partner-access/': typeof UsersPartnerAccessIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/forgot-password'
    | '/login'
    | '/quote-approval'
    | '/set-password'
    | '/settings'
    | '/work-in-progress'
    | '/brands/credit-accounts'
    | '/brands/detail'
    | '/brands/documents'
    | '/brands/hourly-rates-and-commissions'
    | '/brands/projects'
    | '/budgets/edit-quote'
    | '/budgets/export'
    | '/budgets/hourly-rates'
    | '/budgets/positions'
    | '/budgets/quotes'
    | '/clients/credit-accounts'
    | '/clients/detail'
    | '/clients/documents'
    | '/clients/projects'
    | '/contractors/detail'
    | '/credit-accounts/detail'
    | '/credit-accounts/global'
    | '/credit-accounts/global-detail'
    | '/expenses/create'
    | '/expenses/edit'
    | '/projects/budget'
    | '/projects/budgets-old'
    | '/projects/create'
    | '/projects/create-from-template'
    | '/projects/create-template'
    | '/projects/detail'
    | '/projects/documents'
    | '/projects/edit'
    | '/projects/invoicing-plan'
    | '/projects/planned-expenses'
    | '/projects/settings'
    | '/projects/tasks'
    | '/projects/time-billing'
    | '/projects/time-report'
    | '/reports/budget-exceeded'
    | '/reports/invoiced-and-profitability-by-brand'
    | '/reports/invoiced-and-profitability-by-project'
    | '/reports/invoiced-by-brand'
    | '/reports/invoiced-by-project'
    | '/reports/profit-and-loss'
    | '/reports/profitability-by-brand'
    | '/reports/profitability-by-project'
    | '/reports/time-report'
    | '/reports/user-monthly-report'
    | '/reports/user-profit'
    | '/reports/utilization'
    | '/templates/projects'
    | '/templates/task-groups'
    | '/time-tracking/day'
    | '/accept_email_delivery/'
    | '/bank/'
    | '/brands/'
    | '/clients/'
    | '/contractors/'
    | '/documents/'
    | '/expenses/'
    | '/notifications/'
    | '/old-planning/'
    | '/projects/'
    | '/reports/'
    | '/resource-planning/'
    | '/tasks/'
    | '/templates/'
    | '/users/'
    | '/auth/two-factor/challenge'
    | '/auth/two-factor/confirm'
    | '/auth/two-factor/enable'
    | '/auth/two-factor/success'
    | '/budgets/proposals/create'
    | '/invoices/for-invoicing/create-credit-note'
    | '/invoices/for-invoicing/create-invoice'
    | '/invoices/for-invoicing/create-proforma'
    | '/invoices/for-invoicing/duplicate'
    | '/invoices/for-invoicing/edit'
    | '/invoices/invoicing-plan/automated'
    | '/invoices/outgoing-invoices/detail'
    | '/invoices/outgoing-invoices/duplicate'
    | '/invoices/outgoing-invoices/edit'
    | '/invoices/proforma-invoices/detail'
    | '/invoices/proforma-invoices/duplicate'
    | '/invoices/proforma-invoices/edit'
    | '/projects/budgets/create'
    | '/projects/budgets/edit'
    | '/budgets/proposals/'
    | '/invoices/credit-accounts/'
    | '/invoices/for-invoicing/'
    | '/invoices/invoicing-plan/'
    | '/invoices/outgoing-invoices/'
    | '/invoices/proforma-invoices/'
    | '/projects/budgets/'
    | '/resource-planning/my-week/'
    | '/tasks/highlighted/'
    | '/tasks/my-created/'
    | '/tasks/my-current/'
    | '/tasks/my-watched/'
    | '/tasks/my/'
    | '/tasks/pinned/'
    | '/tasks/starred/'
    | '/users/client-access/'
    | '/users/partner-access/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/forgot-password'
    | '/login'
    | '/quote-approval'
    | '/set-password'
    | '/settings'
    | '/work-in-progress'
    | '/brands/credit-accounts'
    | '/brands/detail'
    | '/brands/documents'
    | '/brands/hourly-rates-and-commissions'
    | '/brands/projects'
    | '/budgets/edit-quote'
    | '/budgets/export'
    | '/budgets/hourly-rates'
    | '/budgets/positions'
    | '/budgets/quotes'
    | '/clients/credit-accounts'
    | '/clients/detail'
    | '/clients/documents'
    | '/clients/projects'
    | '/contractors/detail'
    | '/credit-accounts/detail'
    | '/credit-accounts/global'
    | '/credit-accounts/global-detail'
    | '/expenses/create'
    | '/expenses/edit'
    | '/projects/budget'
    | '/projects/budgets-old'
    | '/projects/create'
    | '/projects/create-from-template'
    | '/projects/create-template'
    | '/projects/detail'
    | '/projects/documents'
    | '/projects/edit'
    | '/projects/invoicing-plan'
    | '/projects/planned-expenses'
    | '/projects/settings'
    | '/projects/tasks'
    | '/projects/time-billing'
    | '/projects/time-report'
    | '/reports/budget-exceeded'
    | '/reports/invoiced-and-profitability-by-brand'
    | '/reports/invoiced-and-profitability-by-project'
    | '/reports/invoiced-by-brand'
    | '/reports/invoiced-by-project'
    | '/reports/profit-and-loss'
    | '/reports/profitability-by-brand'
    | '/reports/profitability-by-project'
    | '/reports/time-report'
    | '/reports/user-monthly-report'
    | '/reports/user-profit'
    | '/reports/utilization'
    | '/templates/projects'
    | '/templates/task-groups'
    | '/time-tracking/day'
    | '/accept_email_delivery'
    | '/bank'
    | '/brands'
    | '/clients'
    | '/contractors'
    | '/documents'
    | '/expenses'
    | '/notifications'
    | '/old-planning'
    | '/projects'
    | '/reports'
    | '/resource-planning'
    | '/tasks'
    | '/templates'
    | '/users'
    | '/auth/two-factor/challenge'
    | '/auth/two-factor/confirm'
    | '/auth/two-factor/enable'
    | '/auth/two-factor/success'
    | '/budgets/proposals/create'
    | '/invoices/for-invoicing/create-credit-note'
    | '/invoices/for-invoicing/create-invoice'
    | '/invoices/for-invoicing/create-proforma'
    | '/invoices/for-invoicing/duplicate'
    | '/invoices/for-invoicing/edit'
    | '/invoices/invoicing-plan/automated'
    | '/invoices/outgoing-invoices/detail'
    | '/invoices/outgoing-invoices/duplicate'
    | '/invoices/outgoing-invoices/edit'
    | '/invoices/proforma-invoices/detail'
    | '/invoices/proforma-invoices/duplicate'
    | '/invoices/proforma-invoices/edit'
    | '/projects/budgets/create'
    | '/projects/budgets/edit'
    | '/budgets/proposals'
    | '/invoices/credit-accounts'
    | '/invoices/for-invoicing'
    | '/invoices/invoicing-plan'
    | '/invoices/outgoing-invoices'
    | '/invoices/proforma-invoices'
    | '/projects/budgets'
    | '/resource-planning/my-week'
    | '/tasks/highlighted'
    | '/tasks/my-created'
    | '/tasks/my-current'
    | '/tasks/my-watched'
    | '/tasks/my'
    | '/tasks/pinned'
    | '/tasks/starred'
    | '/users/client-access'
    | '/users/partner-access'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/forgot-password'
    | '/login'
    | '/quote-approval'
    | '/set-password'
    | '/settings'
    | '/work-in-progress'
    | '/brands/credit-accounts'
    | '/brands/detail'
    | '/brands/documents'
    | '/brands/hourly-rates-and-commissions'
    | '/brands/projects'
    | '/budgets/edit-quote'
    | '/budgets/export'
    | '/budgets/hourly-rates'
    | '/budgets/positions'
    | '/budgets/quotes'
    | '/clients/credit-accounts'
    | '/clients/detail'
    | '/clients/documents'
    | '/clients/projects'
    | '/contractors/detail'
    | '/credit-accounts/detail'
    | '/credit-accounts/global'
    | '/credit-accounts/global-detail'
    | '/expenses/create'
    | '/expenses/edit'
    | '/projects/budget'
    | '/projects/budgets-old'
    | '/projects/create'
    | '/projects/create-from-template'
    | '/projects/create-template'
    | '/projects/detail'
    | '/projects/documents'
    | '/projects/edit'
    | '/projects/invoicing-plan'
    | '/projects/planned-expenses'
    | '/projects/settings'
    | '/projects/tasks'
    | '/projects/time-billing'
    | '/projects/time-report'
    | '/reports/budget-exceeded'
    | '/reports/invoiced-and-profitability-by-brand'
    | '/reports/invoiced-and-profitability-by-project'
    | '/reports/invoiced-by-brand'
    | '/reports/invoiced-by-project'
    | '/reports/profit-and-loss'
    | '/reports/profitability-by-brand'
    | '/reports/profitability-by-project'
    | '/reports/time-report'
    | '/reports/user-monthly-report'
    | '/reports/user-profit'
    | '/reports/utilization'
    | '/templates/projects'
    | '/templates/task-groups'
    | '/time-tracking/day'
    | '/accept_email_delivery/'
    | '/bank/'
    | '/brands/'
    | '/clients/'
    | '/contractors/'
    | '/documents/'
    | '/expenses/'
    | '/notifications/'
    | '/old-planning/'
    | '/projects/'
    | '/reports/'
    | '/resource-planning/'
    | '/tasks/'
    | '/templates/'
    | '/users/'
    | '/auth/two-factor/challenge'
    | '/auth/two-factor/confirm'
    | '/auth/two-factor/enable'
    | '/auth/two-factor/success'
    | '/budgets/proposals/create'
    | '/invoices/for-invoicing/create-credit-note'
    | '/invoices/for-invoicing/create-invoice'
    | '/invoices/for-invoicing/create-proforma'
    | '/invoices/for-invoicing/duplicate'
    | '/invoices/for-invoicing/edit'
    | '/invoices/invoicing-plan/automated'
    | '/invoices/outgoing-invoices/detail'
    | '/invoices/outgoing-invoices/duplicate'
    | '/invoices/outgoing-invoices/edit'
    | '/invoices/proforma-invoices/detail'
    | '/invoices/proforma-invoices/duplicate'
    | '/invoices/proforma-invoices/edit'
    | '/projects/budgets/create'
    | '/projects/budgets/edit'
    | '/budgets/proposals/'
    | '/invoices/credit-accounts/'
    | '/invoices/for-invoicing/'
    | '/invoices/invoicing-plan/'
    | '/invoices/outgoing-invoices/'
    | '/invoices/proforma-invoices/'
    | '/projects/budgets/'
    | '/resource-planning/my-week/'
    | '/tasks/highlighted/'
    | '/tasks/my-created/'
    | '/tasks/my-current/'
    | '/tasks/my-watched/'
    | '/tasks/my/'
    | '/tasks/pinned/'
    | '/tasks/starred/'
    | '/users/client-access/'
    | '/users/partner-access/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  QuoteApprovalRoute: typeof QuoteApprovalRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  WorkInProgressRoute: typeof WorkInProgressRoute
  BrandsCreditAccountsRoute: typeof BrandsCreditAccountsRoute
  BrandsDetailRoute: typeof BrandsDetailRoute
  BrandsDocumentsRoute: typeof BrandsDocumentsRoute
  BrandsHourlyRatesAndCommissionsRoute: typeof BrandsHourlyRatesAndCommissionsRoute
  BrandsProjectsRoute: typeof BrandsProjectsRoute
  BudgetsEditQuoteRoute: typeof BudgetsEditQuoteRoute
  BudgetsExportRoute: typeof BudgetsExportRoute
  BudgetsHourlyRatesRoute: typeof BudgetsHourlyRatesRoute
  BudgetsPositionsRoute: typeof BudgetsPositionsRoute
  BudgetsQuotesRoute: typeof BudgetsQuotesRoute
  ClientsCreditAccountsRoute: typeof ClientsCreditAccountsRoute
  ClientsDetailRoute: typeof ClientsDetailRoute
  ClientsDocumentsRoute: typeof ClientsDocumentsRoute
  ClientsProjectsRoute: typeof ClientsProjectsRoute
  ContractorsDetailRoute: typeof ContractorsDetailRoute
  CreditAccountsDetailRoute: typeof CreditAccountsDetailRoute
  CreditAccountsGlobalRoute: typeof CreditAccountsGlobalRoute
  CreditAccountsGlobalDetailRoute: typeof CreditAccountsGlobalDetailRoute
  ExpensesCreateRoute: typeof ExpensesCreateRoute
  ExpensesEditRoute: typeof ExpensesEditRoute
  ProjectsBudgetRoute: typeof ProjectsBudgetRoute
  ProjectsBudgetsOldRoute: typeof ProjectsBudgetsOldRoute
  ProjectsCreateRoute: typeof ProjectsCreateRoute
  ProjectsCreateFromTemplateRoute: typeof ProjectsCreateFromTemplateRoute
  ProjectsCreateTemplateRoute: typeof ProjectsCreateTemplateRoute
  ProjectsDetailRoute: typeof ProjectsDetailRoute
  ProjectsDocumentsRoute: typeof ProjectsDocumentsRoute
  ProjectsEditRoute: typeof ProjectsEditRoute
  ProjectsInvoicingPlanRoute: typeof ProjectsInvoicingPlanRoute
  ProjectsPlannedExpensesRoute: typeof ProjectsPlannedExpensesRoute
  ProjectsSettingsRoute: typeof ProjectsSettingsRoute
  ProjectsTasksRoute: typeof ProjectsTasksRoute
  ProjectsTimeBillingRoute: typeof ProjectsTimeBillingRoute
  ProjectsTimeReportRoute: typeof ProjectsTimeReportRoute
  ReportsBudgetExceededRoute: typeof ReportsBudgetExceededRoute
  ReportsInvoicedAndProfitabilityByBrandRoute: typeof ReportsInvoicedAndProfitabilityByBrandRoute
  ReportsInvoicedAndProfitabilityByProjectRoute: typeof ReportsInvoicedAndProfitabilityByProjectRoute
  ReportsInvoicedByBrandRoute: typeof ReportsInvoicedByBrandRoute
  ReportsInvoicedByProjectRoute: typeof ReportsInvoicedByProjectRoute
  ReportsProfitAndLossRoute: typeof ReportsProfitAndLossRoute
  ReportsProfitabilityByBrandRoute: typeof ReportsProfitabilityByBrandRoute
  ReportsProfitabilityByProjectRoute: typeof ReportsProfitabilityByProjectRoute
  ReportsTimeReportRoute: typeof ReportsTimeReportRoute
  ReportsUserMonthlyReportRoute: typeof ReportsUserMonthlyReportRoute
  ReportsUserProfitRoute: typeof ReportsUserProfitRoute
  ReportsUtilizationRoute: typeof ReportsUtilizationRoute
  TemplatesProjectsRoute: typeof TemplatesProjectsRoute
  TemplatesTaskGroupsRoute: typeof TemplatesTaskGroupsRoute
  TimeTrackingDayRoute: typeof TimeTrackingDayRoute
  Accept_email_deliveryIndexRoute: typeof Accept_email_deliveryIndexRoute
  BankIndexRoute: typeof BankIndexRoute
  BrandsIndexRoute: typeof BrandsIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  ContractorsIndexRoute: typeof ContractorsIndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  ExpensesIndexRoute: typeof ExpensesIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  OldPlanningIndexRoute: typeof OldPlanningIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  ResourcePlanningIndexRoute: typeof ResourcePlanningIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  AuthTwoFactorChallengeRoute: typeof AuthTwoFactorChallengeRoute
  AuthTwoFactorConfirmRoute: typeof AuthTwoFactorConfirmRoute
  AuthTwoFactorEnableRoute: typeof AuthTwoFactorEnableRoute
  AuthTwoFactorSuccessRoute: typeof AuthTwoFactorSuccessRoute
  BudgetsProposalsCreateRoute: typeof BudgetsProposalsCreateRoute
  InvoicesForInvoicingCreateCreditNoteRoute: typeof InvoicesForInvoicingCreateCreditNoteRoute
  InvoicesForInvoicingCreateInvoiceRoute: typeof InvoicesForInvoicingCreateInvoiceRoute
  InvoicesForInvoicingCreateProformaRoute: typeof InvoicesForInvoicingCreateProformaRoute
  InvoicesForInvoicingDuplicateRoute: typeof InvoicesForInvoicingDuplicateRoute
  InvoicesForInvoicingEditRoute: typeof InvoicesForInvoicingEditRoute
  InvoicesInvoicingPlanAutomatedRoute: typeof InvoicesInvoicingPlanAutomatedRoute
  InvoicesOutgoingInvoicesDetailRoute: typeof InvoicesOutgoingInvoicesDetailRoute
  InvoicesOutgoingInvoicesDuplicateRoute: typeof InvoicesOutgoingInvoicesDuplicateRoute
  InvoicesOutgoingInvoicesEditRoute: typeof InvoicesOutgoingInvoicesEditRoute
  InvoicesProformaInvoicesDetailRoute: typeof InvoicesProformaInvoicesDetailRoute
  InvoicesProformaInvoicesDuplicateRoute: typeof InvoicesProformaInvoicesDuplicateRoute
  InvoicesProformaInvoicesEditRoute: typeof InvoicesProformaInvoicesEditRoute
  ProjectsBudgetsCreateRoute: typeof ProjectsBudgetsCreateRoute
  ProjectsBudgetsEditRoute: typeof ProjectsBudgetsEditRoute
  BudgetsProposalsIndexRoute: typeof BudgetsProposalsIndexRoute
  InvoicesCreditAccountsIndexRoute: typeof InvoicesCreditAccountsIndexRoute
  InvoicesForInvoicingIndexRoute: typeof InvoicesForInvoicingIndexRoute
  InvoicesInvoicingPlanIndexRoute: typeof InvoicesInvoicingPlanIndexRoute
  InvoicesOutgoingInvoicesIndexRoute: typeof InvoicesOutgoingInvoicesIndexRoute
  InvoicesProformaInvoicesIndexRoute: typeof InvoicesProformaInvoicesIndexRoute
  ProjectsBudgetsIndexRoute: typeof ProjectsBudgetsIndexRoute
  ResourcePlanningMyWeekIndexRoute: typeof ResourcePlanningMyWeekIndexRoute
  TasksHighlightedIndexRoute: typeof TasksHighlightedIndexRoute
  TasksMyCreatedIndexRoute: typeof TasksMyCreatedIndexRoute
  TasksMyCurrentIndexRoute: typeof TasksMyCurrentIndexRoute
  TasksMyWatchedIndexRoute: typeof TasksMyWatchedIndexRoute
  TasksMyIndexRoute: typeof TasksMyIndexRoute
  TasksPinnedIndexRoute: typeof TasksPinnedIndexRoute
  TasksStarredIndexRoute: typeof TasksStarredIndexRoute
  UsersClientAccessIndexRoute: typeof UsersClientAccessIndexRoute
  UsersPartnerAccessIndexRoute: typeof UsersPartnerAccessIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/work-in-progress': {
      id: '/work-in-progress'
      path: '/work-in-progress'
      fullPath: '/work-in-progress'
      preLoaderRoute: typeof WorkInProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote-approval': {
      id: '/quote-approval'
      path: '/quote-approval'
      fullPath: '/quote-approval'
      preLoaderRoute: typeof QuoteApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resource-planning/': {
      id: '/resource-planning/'
      path: '/resource-planning'
      fullPath: '/resource-planning/'
      preLoaderRoute: typeof ResourcePlanningIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/old-planning/': {
      id: '/old-planning/'
      path: '/old-planning'
      fullPath: '/old-planning/'
      preLoaderRoute: typeof OldPlanningIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/': {
      id: '/expenses/'
      path: '/expenses'
      fullPath: '/expenses/'
      preLoaderRoute: typeof ExpensesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors/': {
      id: '/contractors/'
      path: '/contractors'
      fullPath: '/contractors/'
      preLoaderRoute: typeof ContractorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/': {
      id: '/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof BrandsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bank/': {
      id: '/bank/'
      path: '/bank'
      fullPath: '/bank/'
      preLoaderRoute: typeof BankIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept_email_delivery/': {
      id: '/accept_email_delivery/'
      path: '/accept_email_delivery'
      fullPath: '/accept_email_delivery/'
      preLoaderRoute: typeof Accept_email_deliveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/time-tracking/day': {
      id: '/time-tracking/day'
      path: '/time-tracking/day'
      fullPath: '/time-tracking/day'
      preLoaderRoute: typeof TimeTrackingDayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/task-groups': {
      id: '/templates/task-groups'
      path: '/templates/task-groups'
      fullPath: '/templates/task-groups'
      preLoaderRoute: typeof TemplatesTaskGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/projects': {
      id: '/templates/projects'
      path: '/templates/projects'
      fullPath: '/templates/projects'
      preLoaderRoute: typeof TemplatesProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/utilization': {
      id: '/reports/utilization'
      path: '/reports/utilization'
      fullPath: '/reports/utilization'
      preLoaderRoute: typeof ReportsUtilizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/user-profit': {
      id: '/reports/user-profit'
      path: '/reports/user-profit'
      fullPath: '/reports/user-profit'
      preLoaderRoute: typeof ReportsUserProfitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/user-monthly-report': {
      id: '/reports/user-monthly-report'
      path: '/reports/user-monthly-report'
      fullPath: '/reports/user-monthly-report'
      preLoaderRoute: typeof ReportsUserMonthlyReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/time-report': {
      id: '/reports/time-report'
      path: '/reports/time-report'
      fullPath: '/reports/time-report'
      preLoaderRoute: typeof ReportsTimeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/profitability-by-project': {
      id: '/reports/profitability-by-project'
      path: '/reports/profitability-by-project'
      fullPath: '/reports/profitability-by-project'
      preLoaderRoute: typeof ReportsProfitabilityByProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/profitability-by-brand': {
      id: '/reports/profitability-by-brand'
      path: '/reports/profitability-by-brand'
      fullPath: '/reports/profitability-by-brand'
      preLoaderRoute: typeof ReportsProfitabilityByBrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/profit-and-loss': {
      id: '/reports/profit-and-loss'
      path: '/reports/profit-and-loss'
      fullPath: '/reports/profit-and-loss'
      preLoaderRoute: typeof ReportsProfitAndLossRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/invoiced-by-project': {
      id: '/reports/invoiced-by-project'
      path: '/reports/invoiced-by-project'
      fullPath: '/reports/invoiced-by-project'
      preLoaderRoute: typeof ReportsInvoicedByProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/invoiced-by-brand': {
      id: '/reports/invoiced-by-brand'
      path: '/reports/invoiced-by-brand'
      fullPath: '/reports/invoiced-by-brand'
      preLoaderRoute: typeof ReportsInvoicedByBrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/invoiced-and-profitability-by-project': {
      id: '/reports/invoiced-and-profitability-by-project'
      path: '/reports/invoiced-and-profitability-by-project'
      fullPath: '/reports/invoiced-and-profitability-by-project'
      preLoaderRoute: typeof ReportsInvoicedAndProfitabilityByProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/invoiced-and-profitability-by-brand': {
      id: '/reports/invoiced-and-profitability-by-brand'
      path: '/reports/invoiced-and-profitability-by-brand'
      fullPath: '/reports/invoiced-and-profitability-by-brand'
      preLoaderRoute: typeof ReportsInvoicedAndProfitabilityByBrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/budget-exceeded': {
      id: '/reports/budget-exceeded'
      path: '/reports/budget-exceeded'
      fullPath: '/reports/budget-exceeded'
      preLoaderRoute: typeof ReportsBudgetExceededRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/time-report': {
      id: '/projects/time-report'
      path: '/projects/time-report'
      fullPath: '/projects/time-report'
      preLoaderRoute: typeof ProjectsTimeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/time-billing': {
      id: '/projects/time-billing'
      path: '/projects/time-billing'
      fullPath: '/projects/time-billing'
      preLoaderRoute: typeof ProjectsTimeBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/tasks': {
      id: '/projects/tasks'
      path: '/projects/tasks'
      fullPath: '/projects/tasks'
      preLoaderRoute: typeof ProjectsTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/settings': {
      id: '/projects/settings'
      path: '/projects/settings'
      fullPath: '/projects/settings'
      preLoaderRoute: typeof ProjectsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/planned-expenses': {
      id: '/projects/planned-expenses'
      path: '/projects/planned-expenses'
      fullPath: '/projects/planned-expenses'
      preLoaderRoute: typeof ProjectsPlannedExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/invoicing-plan': {
      id: '/projects/invoicing-plan'
      path: '/projects/invoicing-plan'
      fullPath: '/projects/invoicing-plan'
      preLoaderRoute: typeof ProjectsInvoicingPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/edit': {
      id: '/projects/edit'
      path: '/projects/edit'
      fullPath: '/projects/edit'
      preLoaderRoute: typeof ProjectsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/documents': {
      id: '/projects/documents'
      path: '/projects/documents'
      fullPath: '/projects/documents'
      preLoaderRoute: typeof ProjectsDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/detail': {
      id: '/projects/detail'
      path: '/projects/detail'
      fullPath: '/projects/detail'
      preLoaderRoute: typeof ProjectsDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/create-template': {
      id: '/projects/create-template'
      path: '/projects/create-template'
      fullPath: '/projects/create-template'
      preLoaderRoute: typeof ProjectsCreateTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/create-from-template': {
      id: '/projects/create-from-template'
      path: '/projects/create-from-template'
      fullPath: '/projects/create-from-template'
      preLoaderRoute: typeof ProjectsCreateFromTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/create': {
      id: '/projects/create'
      path: '/projects/create'
      fullPath: '/projects/create'
      preLoaderRoute: typeof ProjectsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/budgets-old': {
      id: '/projects/budgets-old'
      path: '/projects/budgets-old'
      fullPath: '/projects/budgets-old'
      preLoaderRoute: typeof ProjectsBudgetsOldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/budget': {
      id: '/projects/budget'
      path: '/projects/budget'
      fullPath: '/projects/budget'
      preLoaderRoute: typeof ProjectsBudgetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/edit': {
      id: '/expenses/edit'
      path: '/expenses/edit'
      fullPath: '/expenses/edit'
      preLoaderRoute: typeof ExpensesEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/create': {
      id: '/expenses/create'
      path: '/expenses/create'
      fullPath: '/expenses/create'
      preLoaderRoute: typeof ExpensesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credit-accounts/global-detail': {
      id: '/credit-accounts/global-detail'
      path: '/credit-accounts/global-detail'
      fullPath: '/credit-accounts/global-detail'
      preLoaderRoute: typeof CreditAccountsGlobalDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credit-accounts/global': {
      id: '/credit-accounts/global'
      path: '/credit-accounts/global'
      fullPath: '/credit-accounts/global'
      preLoaderRoute: typeof CreditAccountsGlobalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credit-accounts/detail': {
      id: '/credit-accounts/detail'
      path: '/credit-accounts/detail'
      fullPath: '/credit-accounts/detail'
      preLoaderRoute: typeof CreditAccountsDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors/detail': {
      id: '/contractors/detail'
      path: '/contractors/detail'
      fullPath: '/contractors/detail'
      preLoaderRoute: typeof ContractorsDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/projects': {
      id: '/clients/projects'
      path: '/clients/projects'
      fullPath: '/clients/projects'
      preLoaderRoute: typeof ClientsProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/documents': {
      id: '/clients/documents'
      path: '/clients/documents'
      fullPath: '/clients/documents'
      preLoaderRoute: typeof ClientsDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/detail': {
      id: '/clients/detail'
      path: '/clients/detail'
      fullPath: '/clients/detail'
      preLoaderRoute: typeof ClientsDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/credit-accounts': {
      id: '/clients/credit-accounts'
      path: '/clients/credit-accounts'
      fullPath: '/clients/credit-accounts'
      preLoaderRoute: typeof ClientsCreditAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/quotes': {
      id: '/budgets/quotes'
      path: '/budgets/quotes'
      fullPath: '/budgets/quotes'
      preLoaderRoute: typeof BudgetsQuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/positions': {
      id: '/budgets/positions'
      path: '/budgets/positions'
      fullPath: '/budgets/positions'
      preLoaderRoute: typeof BudgetsPositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/hourly-rates': {
      id: '/budgets/hourly-rates'
      path: '/budgets/hourly-rates'
      fullPath: '/budgets/hourly-rates'
      preLoaderRoute: typeof BudgetsHourlyRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/export': {
      id: '/budgets/export'
      path: '/budgets/export'
      fullPath: '/budgets/export'
      preLoaderRoute: typeof BudgetsExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/edit-quote': {
      id: '/budgets/edit-quote'
      path: '/budgets/edit-quote'
      fullPath: '/budgets/edit-quote'
      preLoaderRoute: typeof BudgetsEditQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/projects': {
      id: '/brands/projects'
      path: '/brands/projects'
      fullPath: '/brands/projects'
      preLoaderRoute: typeof BrandsProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/hourly-rates-and-commissions': {
      id: '/brands/hourly-rates-and-commissions'
      path: '/brands/hourly-rates-and-commissions'
      fullPath: '/brands/hourly-rates-and-commissions'
      preLoaderRoute: typeof BrandsHourlyRatesAndCommissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/documents': {
      id: '/brands/documents'
      path: '/brands/documents'
      fullPath: '/brands/documents'
      preLoaderRoute: typeof BrandsDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/detail': {
      id: '/brands/detail'
      path: '/brands/detail'
      fullPath: '/brands/detail'
      preLoaderRoute: typeof BrandsDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/credit-accounts': {
      id: '/brands/credit-accounts'
      path: '/brands/credit-accounts'
      fullPath: '/brands/credit-accounts'
      preLoaderRoute: typeof BrandsCreditAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/partner-access/': {
      id: '/users/partner-access/'
      path: '/users/partner-access'
      fullPath: '/users/partner-access/'
      preLoaderRoute: typeof UsersPartnerAccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/client-access/': {
      id: '/users/client-access/'
      path: '/users/client-access'
      fullPath: '/users/client-access/'
      preLoaderRoute: typeof UsersClientAccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/starred/': {
      id: '/tasks/starred/'
      path: '/tasks/starred'
      fullPath: '/tasks/starred/'
      preLoaderRoute: typeof TasksStarredIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/pinned/': {
      id: '/tasks/pinned/'
      path: '/tasks/pinned'
      fullPath: '/tasks/pinned/'
      preLoaderRoute: typeof TasksPinnedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/my/': {
      id: '/tasks/my/'
      path: '/tasks/my'
      fullPath: '/tasks/my/'
      preLoaderRoute: typeof TasksMyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/my-watched/': {
      id: '/tasks/my-watched/'
      path: '/tasks/my-watched'
      fullPath: '/tasks/my-watched/'
      preLoaderRoute: typeof TasksMyWatchedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/my-current/': {
      id: '/tasks/my-current/'
      path: '/tasks/my-current'
      fullPath: '/tasks/my-current/'
      preLoaderRoute: typeof TasksMyCurrentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/my-created/': {
      id: '/tasks/my-created/'
      path: '/tasks/my-created'
      fullPath: '/tasks/my-created/'
      preLoaderRoute: typeof TasksMyCreatedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/highlighted/': {
      id: '/tasks/highlighted/'
      path: '/tasks/highlighted'
      fullPath: '/tasks/highlighted/'
      preLoaderRoute: typeof TasksHighlightedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resource-planning/my-week/': {
      id: '/resource-planning/my-week/'
      path: '/resource-planning/my-week'
      fullPath: '/resource-planning/my-week/'
      preLoaderRoute: typeof ResourcePlanningMyWeekIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/budgets/': {
      id: '/projects/budgets/'
      path: '/projects/budgets'
      fullPath: '/projects/budgets/'
      preLoaderRoute: typeof ProjectsBudgetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/proforma-invoices/': {
      id: '/invoices/proforma-invoices/'
      path: '/invoices/proforma-invoices'
      fullPath: '/invoices/proforma-invoices/'
      preLoaderRoute: typeof InvoicesProformaInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/outgoing-invoices/': {
      id: '/invoices/outgoing-invoices/'
      path: '/invoices/outgoing-invoices'
      fullPath: '/invoices/outgoing-invoices/'
      preLoaderRoute: typeof InvoicesOutgoingInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/invoicing-plan/': {
      id: '/invoices/invoicing-plan/'
      path: '/invoices/invoicing-plan'
      fullPath: '/invoices/invoicing-plan/'
      preLoaderRoute: typeof InvoicesInvoicingPlanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/': {
      id: '/invoices/for-invoicing/'
      path: '/invoices/for-invoicing'
      fullPath: '/invoices/for-invoicing/'
      preLoaderRoute: typeof InvoicesForInvoicingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/credit-accounts/': {
      id: '/invoices/credit-accounts/'
      path: '/invoices/credit-accounts'
      fullPath: '/invoices/credit-accounts/'
      preLoaderRoute: typeof InvoicesCreditAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/proposals/': {
      id: '/budgets/proposals/'
      path: '/budgets/proposals'
      fullPath: '/budgets/proposals/'
      preLoaderRoute: typeof BudgetsProposalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/budgets/edit': {
      id: '/projects/budgets/edit'
      path: '/projects/budgets/edit'
      fullPath: '/projects/budgets/edit'
      preLoaderRoute: typeof ProjectsBudgetsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/budgets/create': {
      id: '/projects/budgets/create'
      path: '/projects/budgets/create'
      fullPath: '/projects/budgets/create'
      preLoaderRoute: typeof ProjectsBudgetsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/proforma-invoices/edit': {
      id: '/invoices/proforma-invoices/edit'
      path: '/invoices/proforma-invoices/edit'
      fullPath: '/invoices/proforma-invoices/edit'
      preLoaderRoute: typeof InvoicesProformaInvoicesEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/proforma-invoices/duplicate': {
      id: '/invoices/proforma-invoices/duplicate'
      path: '/invoices/proforma-invoices/duplicate'
      fullPath: '/invoices/proforma-invoices/duplicate'
      preLoaderRoute: typeof InvoicesProformaInvoicesDuplicateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/proforma-invoices/detail': {
      id: '/invoices/proforma-invoices/detail'
      path: '/invoices/proforma-invoices/detail'
      fullPath: '/invoices/proforma-invoices/detail'
      preLoaderRoute: typeof InvoicesProformaInvoicesDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/outgoing-invoices/edit': {
      id: '/invoices/outgoing-invoices/edit'
      path: '/invoices/outgoing-invoices/edit'
      fullPath: '/invoices/outgoing-invoices/edit'
      preLoaderRoute: typeof InvoicesOutgoingInvoicesEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/outgoing-invoices/duplicate': {
      id: '/invoices/outgoing-invoices/duplicate'
      path: '/invoices/outgoing-invoices/duplicate'
      fullPath: '/invoices/outgoing-invoices/duplicate'
      preLoaderRoute: typeof InvoicesOutgoingInvoicesDuplicateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/outgoing-invoices/detail': {
      id: '/invoices/outgoing-invoices/detail'
      path: '/invoices/outgoing-invoices/detail'
      fullPath: '/invoices/outgoing-invoices/detail'
      preLoaderRoute: typeof InvoicesOutgoingInvoicesDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/invoicing-plan/automated': {
      id: '/invoices/invoicing-plan/automated'
      path: '/invoices/invoicing-plan/automated'
      fullPath: '/invoices/invoicing-plan/automated'
      preLoaderRoute: typeof InvoicesInvoicingPlanAutomatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/edit': {
      id: '/invoices/for-invoicing/edit'
      path: '/invoices/for-invoicing/edit'
      fullPath: '/invoices/for-invoicing/edit'
      preLoaderRoute: typeof InvoicesForInvoicingEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/duplicate': {
      id: '/invoices/for-invoicing/duplicate'
      path: '/invoices/for-invoicing/duplicate'
      fullPath: '/invoices/for-invoicing/duplicate'
      preLoaderRoute: typeof InvoicesForInvoicingDuplicateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/create-proforma': {
      id: '/invoices/for-invoicing/create-proforma'
      path: '/invoices/for-invoicing/create-proforma'
      fullPath: '/invoices/for-invoicing/create-proforma'
      preLoaderRoute: typeof InvoicesForInvoicingCreateProformaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/create-invoice': {
      id: '/invoices/for-invoicing/create-invoice'
      path: '/invoices/for-invoicing/create-invoice'
      fullPath: '/invoices/for-invoicing/create-invoice'
      preLoaderRoute: typeof InvoicesForInvoicingCreateInvoiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/for-invoicing/create-credit-note': {
      id: '/invoices/for-invoicing/create-credit-note'
      path: '/invoices/for-invoicing/create-credit-note'
      fullPath: '/invoices/for-invoicing/create-credit-note'
      preLoaderRoute: typeof InvoicesForInvoicingCreateCreditNoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets/proposals/create': {
      id: '/budgets/proposals/create'
      path: '/budgets/proposals/create'
      fullPath: '/budgets/proposals/create'
      preLoaderRoute: typeof BudgetsProposalsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/two-factor/success': {
      id: '/auth/two-factor/success'
      path: '/auth/two-factor/success'
      fullPath: '/auth/two-factor/success'
      preLoaderRoute: typeof AuthTwoFactorSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/two-factor/enable': {
      id: '/auth/two-factor/enable'
      path: '/auth/two-factor/enable'
      fullPath: '/auth/two-factor/enable'
      preLoaderRoute: typeof AuthTwoFactorEnableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/two-factor/confirm': {
      id: '/auth/two-factor/confirm'
      path: '/auth/two-factor/confirm'
      fullPath: '/auth/two-factor/confirm'
      preLoaderRoute: typeof AuthTwoFactorConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/two-factor/challenge': {
      id: '/auth/two-factor/challenge'
      path: '/auth/two-factor/challenge'
      fullPath: '/auth/two-factor/challenge'
      preLoaderRoute: typeof AuthTwoFactorChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  QuoteApprovalRoute: QuoteApprovalRoute,
  SetPasswordRoute: SetPasswordRoute,
  SettingsRoute: SettingsRoute,
  WorkInProgressRoute: WorkInProgressRoute,
  BrandsCreditAccountsRoute: BrandsCreditAccountsRoute,
  BrandsDetailRoute: BrandsDetailRoute,
  BrandsDocumentsRoute: BrandsDocumentsRoute,
  BrandsHourlyRatesAndCommissionsRoute: BrandsHourlyRatesAndCommissionsRoute,
  BrandsProjectsRoute: BrandsProjectsRoute,
  BudgetsEditQuoteRoute: BudgetsEditQuoteRoute,
  BudgetsExportRoute: BudgetsExportRoute,
  BudgetsHourlyRatesRoute: BudgetsHourlyRatesRoute,
  BudgetsPositionsRoute: BudgetsPositionsRoute,
  BudgetsQuotesRoute: BudgetsQuotesRoute,
  ClientsCreditAccountsRoute: ClientsCreditAccountsRoute,
  ClientsDetailRoute: ClientsDetailRoute,
  ClientsDocumentsRoute: ClientsDocumentsRoute,
  ClientsProjectsRoute: ClientsProjectsRoute,
  ContractorsDetailRoute: ContractorsDetailRoute,
  CreditAccountsDetailRoute: CreditAccountsDetailRoute,
  CreditAccountsGlobalRoute: CreditAccountsGlobalRoute,
  CreditAccountsGlobalDetailRoute: CreditAccountsGlobalDetailRoute,
  ExpensesCreateRoute: ExpensesCreateRoute,
  ExpensesEditRoute: ExpensesEditRoute,
  ProjectsBudgetRoute: ProjectsBudgetRoute,
  ProjectsBudgetsOldRoute: ProjectsBudgetsOldRoute,
  ProjectsCreateRoute: ProjectsCreateRoute,
  ProjectsCreateFromTemplateRoute: ProjectsCreateFromTemplateRoute,
  ProjectsCreateTemplateRoute: ProjectsCreateTemplateRoute,
  ProjectsDetailRoute: ProjectsDetailRoute,
  ProjectsDocumentsRoute: ProjectsDocumentsRoute,
  ProjectsEditRoute: ProjectsEditRoute,
  ProjectsInvoicingPlanRoute: ProjectsInvoicingPlanRoute,
  ProjectsPlannedExpensesRoute: ProjectsPlannedExpensesRoute,
  ProjectsSettingsRoute: ProjectsSettingsRoute,
  ProjectsTasksRoute: ProjectsTasksRoute,
  ProjectsTimeBillingRoute: ProjectsTimeBillingRoute,
  ProjectsTimeReportRoute: ProjectsTimeReportRoute,
  ReportsBudgetExceededRoute: ReportsBudgetExceededRoute,
  ReportsInvoicedAndProfitabilityByBrandRoute:
    ReportsInvoicedAndProfitabilityByBrandRoute,
  ReportsInvoicedAndProfitabilityByProjectRoute:
    ReportsInvoicedAndProfitabilityByProjectRoute,
  ReportsInvoicedByBrandRoute: ReportsInvoicedByBrandRoute,
  ReportsInvoicedByProjectRoute: ReportsInvoicedByProjectRoute,
  ReportsProfitAndLossRoute: ReportsProfitAndLossRoute,
  ReportsProfitabilityByBrandRoute: ReportsProfitabilityByBrandRoute,
  ReportsProfitabilityByProjectRoute: ReportsProfitabilityByProjectRoute,
  ReportsTimeReportRoute: ReportsTimeReportRoute,
  ReportsUserMonthlyReportRoute: ReportsUserMonthlyReportRoute,
  ReportsUserProfitRoute: ReportsUserProfitRoute,
  ReportsUtilizationRoute: ReportsUtilizationRoute,
  TemplatesProjectsRoute: TemplatesProjectsRoute,
  TemplatesTaskGroupsRoute: TemplatesTaskGroupsRoute,
  TimeTrackingDayRoute: TimeTrackingDayRoute,
  Accept_email_deliveryIndexRoute: Accept_email_deliveryIndexRoute,
  BankIndexRoute: BankIndexRoute,
  BrandsIndexRoute: BrandsIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  ContractorsIndexRoute: ContractorsIndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  ExpensesIndexRoute: ExpensesIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  OldPlanningIndexRoute: OldPlanningIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ResourcePlanningIndexRoute: ResourcePlanningIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  AuthTwoFactorChallengeRoute: AuthTwoFactorChallengeRoute,
  AuthTwoFactorConfirmRoute: AuthTwoFactorConfirmRoute,
  AuthTwoFactorEnableRoute: AuthTwoFactorEnableRoute,
  AuthTwoFactorSuccessRoute: AuthTwoFactorSuccessRoute,
  BudgetsProposalsCreateRoute: BudgetsProposalsCreateRoute,
  InvoicesForInvoicingCreateCreditNoteRoute:
    InvoicesForInvoicingCreateCreditNoteRoute,
  InvoicesForInvoicingCreateInvoiceRoute:
    InvoicesForInvoicingCreateInvoiceRoute,
  InvoicesForInvoicingCreateProformaRoute:
    InvoicesForInvoicingCreateProformaRoute,
  InvoicesForInvoicingDuplicateRoute: InvoicesForInvoicingDuplicateRoute,
  InvoicesForInvoicingEditRoute: InvoicesForInvoicingEditRoute,
  InvoicesInvoicingPlanAutomatedRoute: InvoicesInvoicingPlanAutomatedRoute,
  InvoicesOutgoingInvoicesDetailRoute: InvoicesOutgoingInvoicesDetailRoute,
  InvoicesOutgoingInvoicesDuplicateRoute:
    InvoicesOutgoingInvoicesDuplicateRoute,
  InvoicesOutgoingInvoicesEditRoute: InvoicesOutgoingInvoicesEditRoute,
  InvoicesProformaInvoicesDetailRoute: InvoicesProformaInvoicesDetailRoute,
  InvoicesProformaInvoicesDuplicateRoute:
    InvoicesProformaInvoicesDuplicateRoute,
  InvoicesProformaInvoicesEditRoute: InvoicesProformaInvoicesEditRoute,
  ProjectsBudgetsCreateRoute: ProjectsBudgetsCreateRoute,
  ProjectsBudgetsEditRoute: ProjectsBudgetsEditRoute,
  BudgetsProposalsIndexRoute: BudgetsProposalsIndexRoute,
  InvoicesCreditAccountsIndexRoute: InvoicesCreditAccountsIndexRoute,
  InvoicesForInvoicingIndexRoute: InvoicesForInvoicingIndexRoute,
  InvoicesInvoicingPlanIndexRoute: InvoicesInvoicingPlanIndexRoute,
  InvoicesOutgoingInvoicesIndexRoute: InvoicesOutgoingInvoicesIndexRoute,
  InvoicesProformaInvoicesIndexRoute: InvoicesProformaInvoicesIndexRoute,
  ProjectsBudgetsIndexRoute: ProjectsBudgetsIndexRoute,
  ResourcePlanningMyWeekIndexRoute: ResourcePlanningMyWeekIndexRoute,
  TasksHighlightedIndexRoute: TasksHighlightedIndexRoute,
  TasksMyCreatedIndexRoute: TasksMyCreatedIndexRoute,
  TasksMyCurrentIndexRoute: TasksMyCurrentIndexRoute,
  TasksMyWatchedIndexRoute: TasksMyWatchedIndexRoute,
  TasksMyIndexRoute: TasksMyIndexRoute,
  TasksPinnedIndexRoute: TasksPinnedIndexRoute,
  TasksStarredIndexRoute: TasksStarredIndexRoute,
  UsersClientAccessIndexRoute: UsersClientAccessIndexRoute,
  UsersPartnerAccessIndexRoute: UsersPartnerAccessIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
